import React from 'react'
import { Label, Content, Wrapper, Icon } from './styles'

export default ({
  children,
  label,
  border = false,
  name,
  open,
  onClick,
  alwaysOpen = false,
}) => {
  return (
    <Wrapper border={border}>
      <Label
        onClick={() =>
          onClick(prevState => {
            const result = { ...prevState }

            Object.keys(result).forEach(item => {
              if (item !== name) result[item] = false
            })

            result[name] = !open

            return result
          })
        }
      >
        {label}
        {!alwaysOpen && <Icon open={open} />}
      </Label>
      <Content open={!alwaysOpen ? open : alwaysOpen}>{children}</Content>
    </Wrapper>
  )
}
